module.exports = __webpack_public_path__ + "static/media/code2.f802f0e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/code2.jpg
// module id = 256
// module chunks = 0